import { ExamType } from '../../api/exam';
import Segment from '../shared/segment';

export type ExamPropsType = {
  exam: ExamType;
};

function Exam({ exam }: ExamPropsType) {
  const studentCountIsUpdating = !exam.expired || !exam.isExpired;

  return (
    <Segment bg noMargin color='sky'>
      <p className='mb-4 text-center text-lg font-medium'>کارنامه {exam.name}</p>
      <div className='grid gap-2 text-sm md:grid-cols-3'>
        <p className='md:text-center'>
          <span className='font-medium'>تعداد سوالات: </span>
          <span>{exam.questionCount}</span>
        </p>
        <p className='md:text-center'>
          <span className='font-medium'>نمره منفی: </span>
          <span>{exam.penalty ? 'دارد' : 'ندارد'}</span>
        </p>
        <p className='md:text-center'>
          <span className='font-medium'>تعداد شرکت‌کنندگان </span>
          {studentCountIsUpdating ? (
            <span className='font-medium text-red-500'>تا این لحظه</span>
          ) : (
            <span className='font-medium'>نهایی</span>
          )}
          <span className='font-medium'>: </span>
          <span>{exam.studentFinishedCount}</span>
        </p>
      </div>
    </Segment>
  );
}

export default Exam;
